import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p428769218835574784',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
